/*
 *
 * CostsCustomDownloadModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 16-Jul-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CostsCustomDownloadModal from './CostsCustomDownloadModal'
import { nullSafe } from 'Utility/globalMethods'
import * as CostsActions from '../../routes/Costs/modules/CostsActions'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(CostsActions, dispatch)
})

const mapStateToProps = (state) => ({
  title: nullSafe(() => state.popup.popupInfo.title, ''),
  description: nullSafe(() => state.popup.popupInfo.description, ''),
  children: nullSafe(() => state.popup.popupInfo.children, null),
  onClose: nullSafe(() => state.popup.popupInfo.onClose, () => { }),
  primaryButtonLabel: nullSafe(() => state.popup.popupInfo.primaryButtonLabel, ''),
  secondaryButtonLabel: nullSafe(() => state.popup.popupInfo.secondaryButtonLabel, ''),
  titleMerchantGenericCard: nullSafe(() => state.popup.popupInfo.titleMerchantGenericCard, ''),
  subtitleMerchantGenericCard: nullSafe(() => state.popup.popupInfo.subtitleMerchantGenericCard, ''),
  options: nullSafe(() => state.popup.popupInfo.options, []),
  formatInfoMessage: nullSafe(() => state.popup.popupInfo.formatInfoMessage, ''),
  labelMerchantToastMessage: nullSafe(() => state.popup.popupInfo.labelMerchantToastMessage, ''),
  downloadType: nullSafe(() => state.popup.popupInfo.downloadType, ''),
  requestParams: nullSafe(() => state.popup.popupInfo.requestParams, ''),
  setDownloadIdFromModal: nullSafe(() => state.popup.popupInfo.setDownloadIdFromModal, () => { }),
  isAsyncDownloadLoading: nullSafe(() => state.loading.localLoading.get_start_download_credit || state.loading.localLoading.get_start_download_debit || state.loading.localLoading.get_start_download_commissions || state.loading.localLoading.get_start_download_credit_details, false),
  isSyncDownloadLoading: nullSafe(() => state.loading.localLoading.get_download_credit || state.loading.localLoading.get_download_debit || state.loading.localLoading.get_download_commissions || state.loading.localLoading.get_download_credit_details || state.loading.localLoading.get_download_debit_details, false),
  syncDownload: nullSafe(() => state.popup.popupInfo.syncDownload, () => { }),
  asyncDownload: nullSafe(() => state.popup.popupInfo.asyncDownload, () => { }),
  filters: nullSafe(() => state.popup.popupInfo.filters, {}),
  typeTabDownload: nullSafe(() => state.popup.popupInfo.typeTabDownload, ''),
  isDetailsDownload: nullSafe(() => state.popup.popupInfo.isDetailsDownload, false),
  isBlockedDownload: nullSafe(() => state.popup.popupInfo.isBlockedDownload, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(CostsCustomDownloadModal)
